import {HttpInterceptor, HttpRequest} from "@gsb/react-http";
import {environment} from "../env";

export class DefaultHeaderInterceptor implements HttpInterceptor {

    willSendRequest = async (req: HttpRequest) => {
        req.headers.set('sales-channel-identifier', environment.salesChannelIdentifier)
        return req
    };
}